export const TITLE_API_BASE_URI = process.env.REACT_APP_TITLE_API__URL;
